import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { ReserveProvider } from "./context/ReserveContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Stats from "./components/Stats";
import Facilities from "./components/Facilities";
import Services from "./components/Services";
import Schedule from "./components/Schedule";
import Pricing from "./components/Pricing";
import Location from "./components/Location";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

import AppDownload from "./components/AppDownload";
import InaugurationBanner from "./components/InaugurationBanner";
import AdminLogin from "./pages/AdminLogin";
import LegalPage from "./pages/LegalPage";
import MachinePage from "./pages/MachinePage";
import ActivatePage from "./pages/ActivatePage";
import UserLoginPage from "./pages/UserLoginPage";
import OnboardingSafetyPage from "./pages/OnboardingSafetyPage";
import OnboardingPersonalizationPage from "./pages/OnboardingPersonalizationPage";
import MyRoutinePage from "./pages/MyRoutinePage";
import MyEvolutionPage from "./pages/MyEvolutionPage";
import MachineCatalogPage from "./pages/MachineCatalogPage";
import InicioPage from "./pages/InicioPage";
import { UserAuthProvider } from "./context/UserAuthContext";
// Admin panel (new layout + tabs)
import AdminLayout from "./pages/admin/AdminLayout";
import SociosTab from "./pages/admin/SociosTab";
import MaquinasTab from "./pages/admin/MaquinasTab";
import RutinasTab from "./pages/admin/RutinasTab";
import EjerciciosTab from "./pages/admin/EjerciciosTab";
import EmailsTab from "./pages/admin/EmailsTab";
import ProductosTab from "./pages/admin/ProductosTab";
import ReservasTab from "./pages/admin/ReservasTab";
import TiendaPage from "./pages/TiendaPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import ReservasPage from "./pages/ReservasPage";
import MisComprasPage from "./pages/MisComprasPage";

const Landing = () => {
  return (
    <ReserveProvider>
      <div className="bg-black text-white min-h-screen" data-testid="landing-page">
        
        <Navbar />
        <main>
          <InaugurationBanner />
          <Hero />
          <Marquee />
          <Stats />
          <Facilities />
          <Services />
          <Schedule />
          <Pricing />
          <AppDownload />
          <Location />
          <FAQ />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </ReserveProvider>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <UserAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="socios" replace />} />
                <Route path="socios" element={<SociosTab />} />
                <Route path="maquinas"   element={<MaquinasTab />} />
                <Route path="ejercicios" element={<EjerciciosTab />} />
                <Route path="rutinas"    element={<RutinasTab />} />
                <Route path="productos" element={<ProductosTab />} />
                <Route path="reservas" element={<ReservasTab />} />
                <Route path="emails" element={<EmailsTab />} />
                <Route path="app-socios" element={<Navigate to="/admin/socios" replace />} />
              </Route>
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/maquina/:numero" element={<MachinePage />} />
              <Route path="/activar/:token" element={<ActivatePage />} />
              <Route path="/login" element={<UserLoginPage />} />
              <Route path="/inicio" element={<InicioPage />} />
              <Route path="/onboarding/seguridad" element={<OnboardingSafetyPage />} />
              <Route path="/onboarding/personalizacion" element={<OnboardingPersonalizationPage />} />
              <Route path="/mi-rutina" element={<MyRoutinePage />} />
              <Route path="/mi-evolucion" element={<MyEvolutionPage />} />
              <Route path="/catalogo" element={<MachineCatalogPage />} />
              <Route path="/tienda" element={<TiendaPage />} />
              <Route path="/reservas" element={<ReservasPage />} />
              <Route path="/mis-compras" element={<MisComprasPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<Navigate to="/tienda" replace />} />
              <Route path="/portal" element={<Navigate to="/inicio" replace />} />
            </Routes>
          </BrowserRouter>
        </UserAuthProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
